import React, { useState } from "react";
import { Row, Col, Card, Switch } from "antd";

const NotificationSettings = ({
  user,
  widget,
  handleWidgetChange,
  handleSound,
}) => {
  const [disableActiveVisitorSound, setDisableActiveVisitorSound] = useState(
    user?.disableActiveVisitorSound
  );
  const handleChange = (e, label) => {
    handleWidgetChange({ [label]: e, id: widget.id });
  };
  const handleMsgPreview = (e, label) => {
    let prevObj = {
      ...widget?.disableMsgPreview,
      [label]: e,
    };

    handleWidgetChange({ disableMsgPreview: prevObj, id: widget.id });
  };
  const handleActiveVistorSound = (e, label) => {
    handleSound({ [label]: e, id: widget.id });
  };

  return (
    <Card className="setting_wrapper">
      <h4 className="p-color">Notification Settings</h4>
      <Row gutter={[12, 0]}>
        <Col span={24}>
          <ul className="switch_lst">
            {/* <li>
              <Switch
                id="custom-switch"
                disabled={!
                name="pre_chat_form"
                onChange={(e) => handleChange(!e, "waitTime")}
                defaultChecked={widget?.waitTime}
                checked={widget?.waitTime}
              />
              <span>Hide estimated wait time</span>
            </li> */}
            <li>
              <Switch
                id="custom-switch"
                name="pre_chat_form"
                onChange={(e) => {
                  setDisableActiveVisitorSound(e);
                  handleActiveVistorSound(e, "disableActiveVisitorSound");
                }}
                defaultChecked={disableActiveVisitorSound}
                checked={disableActiveVisitorSound}
              />
              <span>Disable active visitor sound notification</span>
            </li>
            <li>
              <Switch
                id="custom-switch"
                name="pre_chat_form"
                onChange={(e) => handleChange(e, "soundNotification")}
                defaultChecked={widget?.soundNotification}
                checked={widget?.soundNotification}
              />
              <span>Disable message sound notification</span>
            </li>

            <li>
              <Switch
                id="custom-switch"
                name="pre_chat_form"
                onChange={(e) => handleMsgPreview(e, "desktop")}
                defaultChecked={widget?.disableMsgPreview?.desktop}
                checked={widget?.disableMsgPreview?.desktop}
              />
              <span>Disable message preview on desktop</span>
            </li>

            <li>
              <Switch
                id="custom-switch"
                name="pre_chat_form"
                onChange={(e) => handleMsgPreview(e, "mobile")}
                defaultChecked={widget?.disableMsgPreview?.mobile}
                checked={widget?.disableMsgPreview?.mobile}
              />
              <span>Disable message preview on mobile</span>
            </li>

            <li>
              <Switch
                id="custom-switch"
                name="pre_chat_form"
                onChange={(e) => handleChange(e, "visitorTyping")}
                defaultChecked={widget?.visitorTyping}
                checked={widget?.visitorTyping}
              />
              <span>Disable visitor typing notification</span>
            </li>

            <li>
              <Switch
                id="custom-switch"
                name="pre_chat_form"
                onChange={(e) =>
                  handleChange(e, "disableBrowserTabNotification")
                }
                defaultChecked={widget?.disableBrowserTabNotification}
                checked={widget?.disableBrowserTabNotification}
              />
              <span>Disable browser tab notification</span>
            </li>
          </ul>
        </Col>
      </Row>
    </Card>
  );
};

export default React.memo(NotificationSettings);
